import { Observable, map } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { SelectSearchData } from "src/app/shared/select-search/select-search.data";
import { ApiService } from "./_api.service";
import { Customer } from "src/app/_models/customer";
import { environment } from 'src/environments/environment';  // Importa environment per la base URL

export class CustomerApiService {
    constructor(private _ws: WebServicesService) {}

    // Customer methods
    get(): Observable<Customer[]> {
        const url = `${environment.wsBaseUrl}/api/Customer/all`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_CUSTOMERS);
    }

    getSelect(): Observable<SelectSearchData[]> {
        const url = `${environment.wsBaseUrl}/api/Customer/selectAll`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_CUSTOMERS_SELECT);
    }

    getList(ids: number[]): Observable<string> {
        const url = `${environment.wsBaseUrl}/api/Customer/list?${ids.map(id => `Id=${encodeURIComponent(id)}`).join('&')}`;
        return this._ws.getCsvContent(url);
    }

    getOne(id: number): Observable<Customer> {
        const url = `${environment.wsBaseUrl}/api/Customer/${encodeURIComponent(id)}`;
        return this._ws.getWithoutCache(url).pipe(
            map(cus => {
                cus.createdDateTime = new Date(cus.createdDateTime);
                cus.modifiedDateTime = new Date(cus.modifiedDateTime);
                return cus;
            })
        );
    }

    put(customer: Customer) {
        const url = `${environment.wsBaseUrl}/api/Customer/${encodeURIComponent(customer.id)}`;
        return this._ws.putJson(url, customer);
    }

    post(customer: Customer): Observable<Customer> {
        const url = `${environment.wsBaseUrl}/api/Customer/`;
        return this._ws.postJson(url, customer);
    }

    delete(customer: Customer) {
        const url = `${environment.wsBaseUrl}/api/Customer/${encodeURIComponent(customer.id)}`;
        return this._ws.deleteHttp(url);
    }
}
